export default {
      fr: {
            Global: {
                  hello: 'Bonjour.',    
            }
      },
      en: {
            Global: {
                  hello: 'Hell0o',
            }        
      }
}
